module.exports = __webpack_public_path__ + "static/media/bhim.b588bc61.png";